import { useEffect, useRef } from "react";

// Wait for the smooth-scroll animation to settle before focusing the name
// input so the focus action doesn't fight with the scroll.
const FOCUS_AFTER_SCROLL_MS = 700;

const TEMPLATES = {
  pt: (p, b) =>
    `Olá, tenho interesse em receber orçamento para o produto ${p}${
      b ? ` (${b})` : ""
    }. Podem indicar preço, disponibilidade e prazo de entrega? Obrigado.`,
  en: (p, b) =>
    `Hello, I'd like to receive a quote for the product ${p}${
      b ? ` (${b})` : ""
    }. Can you share price, availability and lead time? Thank you.`,
  es: (p, b) =>
    `Hola, me gustaría recibir una cotización para el producto ${p}${
      b ? ` (${b})` : ""
    }. ¿Pueden indicar precio, disponibilidad y tiempo de entrega? Gracias.`,
};

const SUBJECTS = { pt: "Orçamento", en: "Quote", es: "Presupuesto" };

/**
 * Reads ?produto=&marca= from the URL once on mount (and on language change)
 * to pre-fill the contact form, scroll the section into view, focus the name
 * input and clean the query string so reload doesn't re-prefill.
 *
 * @param {(updater) => void} setForm - React setter from the parent form state.
 * @param {string} lang - Active interface language.
 */
export const useContactQueryPrefill = (setForm, lang) => {
  // Track the last lang we processed so we only re-run when language actually
  // changes (not on every parent re-render that might pass new setForm refs).
  const lastLangRef = useRef(null);

  useEffect(() => {
    if (lastLangRef.current === lang) return;
    lastLangRef.current = lang;

    const params = new URLSearchParams(window.location.search);
    const produto = params.get("produto");
    const marca = params.get("marca");
    if (!produto) return;

    const tpl = TEMPLATES[lang] || TEMPLATES.pt;
    const subjectValue = SUBJECTS[lang] || SUBJECTS.pt;

    setForm((f) => ({
      ...f,
      subject: subjectValue,
      message: tpl(produto, marca),
    }));

    document.getElementById("contact")
      ?.scrollIntoView({ behavior: "smooth", block: "start" });

    setTimeout(() => {
      document.querySelector('[data-testid="contact-input-name"]')?.focus();
    }, FOCUS_AFTER_SCROLL_MS);

    const url = new URL(window.location.href);
    url.searchParams.delete("produto");
    url.searchParams.delete("marca");
    window.history.replaceState({}, "", url.toString());
  }, [setForm, lang]);
};
